import { array, bool, func, string } from 'prop-types';
import Modal from 'ps-components/Modal/Modal';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import ModalFooter from 'ps-components/Modal/ModalFooter/ModalFooter';
import React, { useEffect, useState } from 'react';
import './AddNewSurveyModal.scss';

function AddNewSurveyModal(props) {
  const OTHER_PUBLISHER_OPTION = 'Other';

  useEffect(() => {
    props.getPublishers();
  }, []);

  const [otherPublisherName, setOtherPublisherName] = useState(null);

  function getPublisherOptions() {
    const publisherOptions = props.publishers?.map(publisher => publisher.publisherName) || [];
    publisherOptions.push(OTHER_PUBLISHER_OPTION);
    return publisherOptions;
  }

  function onOtherPublisherNameChange(event) {
    setOtherPublisherName(event.target.value);
  }

  function onSurveyNameChange(event) {
    props.onSurveyNameChange(event.target.value);
  }

  function onSurveyAdd() {
    const publisherName =
      props.selectedPublisher === OTHER_PUBLISHER_OPTION ? otherPublisherName : props.selectedPublisher;
    return props.onSurveyAdd(`${publisherName} - ${props.surveyName}`);
  }

  function hasCompletedFields() {
    if (!props.selectedPublisher || !props.surveyName) {
      return false;
    } else if (props.selectedPublisher === OTHER_PUBLISHER_OPTION && !otherPublisherName) {
      return false;
    }
    return true;
  }

  function onClose() {
    setOtherPublisherName(null);
    props.onClose();
  }

  return (
    <Modal className="add-new-survey__modal" allowClose={true} show={props.show} onClose={props.onClose}>
      <ModalHeader>
        <h3>Add New Survey</h3>
      </ModalHeader>
      <ModalBody>
        {props.hasError && (
          <div className="add-survey-error__label">Error occurred while adding the survey, please try again later.</div>
        )}
        <div className="add-new-survey__form-label">Survey Publisher</div>
        <Dropdown
          className="publishers__dropdown"
          dropdownItems={getPublisherOptions()}
          text={props.selectedPublisher || 'Select'}
          rightBound={false}
          itemOnClick={props.onPublisherClick}
        />
        {props.selectedPublisher === OTHER_PUBLISHER_OPTION && (
          <React.Fragment>
            <div className="add-new-survey__form-label">Specify Survey Publisher</div>
            <input
              type="text"
              value={otherPublisherName}
              onChange={onOtherPublisherNameChange}
              className="pxl-form-control other-publisher-name__input"
            />
          </React.Fragment>
        )}
        <div className="add-new-survey__form-label">Survey Name</div>
        <textarea
          value={props.surveyName}
          onChange={onSurveyNameChange}
          className="pxl-form-control pxl-form-textarea survey-name__textarea"
        />
      </ModalBody>
      <ModalFooter
        cancelBtnClick={onClose}
        submitBtnClick={onSurveyAdd}
        saveButtonDisabled={props.isAdding || props.isLoadingPublishers || !hasCompletedFields()}
        submitBtnTxtName={props.isAdding ? <i className="icon-animate-spin icon-spin" /> : 'Add Survey'}
      />
    </Modal>
  );
}

AddNewSurveyModal.propTypes = {
  getPublishers: func,
  onClose: func,
  onAdd: func,
  show: bool,
  isAdding: bool,
  hasError: bool,
  isLoadingPublishers: bool,
  publishers: array,
  surveyName: string,
  onSurveyNameChange: func,
  selectedPublisher: string,
  onPublisherClick: func,
  onSurveyAdd: func
};

export default AddNewSurveyModal;
